import { CARD_TYPE, moneyFormat } from 'easyguide'
import { saveAs } from 'file-saver'
import formatDate from 'utils/dateFormater'

const initialState = {
  isFetching: false,
  isFetched: false,
  success: false,
  error: false,
  data: null,
  origin: [],
  selectedOrigin: null,
  selectedSecurity: null,
  startDate: null,
  displayStartDate: null,
  endDate: null,
  displayEndDate: null,
  summary: null
}

export const ACTION_TYPES = {
  TRANSACTION_HISTORY_REQUEST: 'TRANSACTION_HISTORY_REQUEST',
  TRANSACTION_HISTORY_SUCCESS: 'TRANSACTION_HISTORY_SUCCESS',
  TRANSACTION_HISTORY_ERROR: 'TRANSACTION_HISTORY_ERROR',

  TRANSACTION_HISTORY_SUMMARY_REQUEST: 'TRANSACTION_HISTORY_SUMMARY_REQUEST',
  TRANSACTION_HISTORY_SUMMARY_SUCCESS: 'TRANSACTION_HISTORY_SUMMARY_SUCCESS',
  TRANSACTION_HISTORY_SUMMARY_ERROR: 'TRANSACTION_HISTORY_SUMMARY_ERROR',

  TRANSACTION_HISTORY_REPORT_REQUEST: 'TRANSACTION_HISTORY_REPORT_REQUEST',
  TRANSACTION_HISTORY_REPORT_SUCCESS: 'TRANSACTION_HISTORY_REPORT_SUCCESS',
  TRANSACTION_HISTORY_REPORT_ERROR: 'TRANSACTION_HISTORY_REPORT_ERROR',

  TRANSACTION_HISTORY_SELECT_ORIGIN: 'TRANSACTION_HISTORY_SELECT_ORIGIN',
  TRANSACTION_HISTORY_SELECT_SECURITY_CLEAR: 'TRANSACTION_HISTORY_SELECT_SECURITY_CLEAR',

  TRANSACTION_HISTORY_START_DATE: 'TRANSACTION_HISTORY_START_DATE',
  TRANSACTION_HISTORY_END_DATE: 'TRANSACTION_HISTORY_END_DATE',

  TRANSACTION_HISTORY_CLEAR_STORE: 'TRANSACTION_HISTORY_CLEAR_STORE'
}

const getOriginAccounts = (state, { data }) => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    data,
    origin: []
  }
  const accounts = data || {}
  accounts.forEach(item => {
    if (item.accountTypeId !== CARD_TYPE.TD) {
      newState.origin.push(
        {
          key: item.accountTypeId,
          value: item.description,
          accountType: item.accountTypeId,
          accountNumber: item.accountNumber
        }
      )
    }
  })
  if (newState.origin.length === 1) newState.selectedOrigin = newState.origin[0]
  return newState
}
const getSummary = (state, { data: { value } }) => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    summary: {
      properties: [
        {
          key: 'settlementDate',
          value: 'Dt. Negociação.'
        },
        {
          key: 'ticker',
          value: 'Ativo'
        },
        {
          key: 'buyQuantity',
          value: 'Qtde. compra'
        },
        {
          key: 'sellQuantity',
          value: 'Qtde. venda'
        },
        {
          key: 'price',
          value: 'Preço'
        },
        {
          key: 'buyValue',
          value: 'Valor financeiro compras'
        },
        {
          key: 'sellValue',
          value: 'Valor financeiro vendas'
        }
      ],
      data: []
    }
  }
  newState.summary.data = value.statements.map(statement => ({
    settlementDate: formatDate(statement.settlementDate),
    price: moneyFormat(statement.price),
    buyQuantity: statement.buyQuantity,
    sellQuantity: statement.sellQuantity,
    buyValue: moneyFormat(statement.buyValue),
    sellValue: moneyFormat(statement.sellValue),
    ticker: statement.ticker
  }))
  return newState
}

export const getTransactionHistory = () => ({
  type: ACTION_TYPES.TRANSACTION_HISTORY_REQUEST
})

export const getTransactionHistorySummary = payload => ({
  type: ACTION_TYPES.TRANSACTION_HISTORY_SUMMARY_REQUEST,
  payload
})

export const getTransactionHistoryReport = payload => ({
  type: ACTION_TYPES.TRANSACTION_HISTORY_REPORT_REQUEST,
  payload
})

export const setItemOrigin = payload => ({
  type: ACTION_TYPES.TRANSACTION_HISTORY_SELECT_ORIGIN,
  payload
})

export const setStartDate = payload => ({
  type: ACTION_TYPES.TRANSACTION_HISTORY_START_DATE,
  payload
})

export const setEndDate = payload => ({
  type: ACTION_TYPES.TRANSACTION_HISTORY_END_DATE,
  payload
})

export const clearSelectedSecurity = () => ({
  type: ACTION_TYPES.TRANSACTION_HISTORY_SELECT_SECURITY_CLEAR
})

export const clearTransactionHistoryStore = () => ({
  type: ACTION_TYPES.TRANSACTION_HISTORY_CLEAR_STORE
})

const transactionHistory = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.TRANSACTION_HISTORY_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false
      }
    case ACTION_TYPES.TRANSACTION_HISTORY_SUCCESS:
      return getOriginAccounts(state, payload)
    case ACTION_TYPES.TRANSACTION_HISTORY_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: true,
        data: payload
      }
    case ACTION_TYPES.TRANSACTION_HISTORY_SUMMARY_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.TRANSACTION_HISTORY_SUMMARY_SUCCESS:
      return getSummary(state, payload)
    case ACTION_TYPES.TRANSACTION_HISTORY_SUMMARY_ERROR:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        error: true,
        summary: null,
        data: payload
      }
    case ACTION_TYPES.TRANSACTION_HISTORY_REPORT_REQUEST:
      return state
    case ACTION_TYPES.TRANSACTION_HISTORY_REPORT_SUCCESS:
      saveAs(new Blob([payload.response.data], { type: payload.format }), payload.fileName)
      return state
    case ACTION_TYPES.TRANSACTION_HISTORY_REPORT_ERROR:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        error: true,
        data: payload
      }
    case ACTION_TYPES.TRANSACTION_HISTORY_SELECT_ORIGIN:
      return {
        ...state,
        selectedOrigin: payload
      }
    case ACTION_TYPES.TRANSACTION_HISTORY_START_DATE:
      return {
        ...state,
        startDate: payload,
        endDate: null,
        displayStartDate: formatDate(payload),
        displayEndDate: null
      }
    case ACTION_TYPES.TRANSACTION_HISTORY_END_DATE:
      return {
        ...state,
        endDate: payload,
        displayEndDate: formatDate(payload)
      }
    case ACTION_TYPES.TRANSACTION_HISTORY_SELECT_SECURITY_CLEAR:
      return {
        ...state,
        selectedSecurity: {
          avaliableQuantity: 0,
          inAnaliseQuantity: 0,
          key: '',
          securityId: '',
          securityName: '',
          securityValue: 0,
          unitPrice: 0,
          value: ''
        }
      }
    case ACTION_TYPES.TRANSACTION_HISTORY_CLEAR_STORE:
      return initialState
    default:
      return state
  }
}

export default transactionHistory
